import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import { Link } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
const Statistics = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const ComingSoon = location.state;
    //   const categoryId = ComingSoon?.categoryId;
    const skitName = ComingSoon?.skitname;
    console.log("Coming Soon Data : ", skitName)
    const [activePage, setActivePage] = useState("Profile");
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
    console.log(SelectLanguageLocal, "SelectLanguageLocal")
    const { Translate } = useContext(ProductContext);
    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = localStorage.getItem("selectedLanguage");
                console.log("storedLanguage", storedLanguage);
                if (storedLanguage) {
                    setSelectedLanguage(storedLanguage);
                }
            } catch (error) {
                console.error("Error loading language:", error);
            }
        };

        loadLanguage();
    }, []);
    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />
                            <h2>{Translate?.message?.data?.statisticsAndResults || "Statistics And Results"}</h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>


            <div className="statics-message-box">
                <h4>
                    つづく
                </h4>


                <h5>
                    {Translate?.message?.data?.sorry || "Sorry!"}
                </h5>

                <img
                    src={`${process.env.PUBLIC_URL}/assets/images/announce.jpg`}
                    alt="No Questions Found"
                    style={{
                        width: '250px',
                        height: '250px',
                        objectFit: 'cover',
                        marginTop: '30px', // Reduced margin to bring it higher
                        marginLeft: 'auto', // Center horizontally
                        marginRight: 'auto',
                        display: 'block', // Ensures it works with auto margins
                    }}

                />
                <button onClick={() => navigate("/")} className="Statics-action-button">
                    {Translate?.message?.data?.returnBackToHome || "Return Back to Home"}
                </button>
            </div>
      <Footer />
    </div>
  );
};

export default Statistics;
